<template>
    <div class="container">
        <div class="box-share">
            <div class="model"></div>
            <div class="box-content">
                <div class="box-title">领取成功</div>
                <div class="btn-container">
                    <div class="btn-container-content">
                        <div class="list">
                            <div class="item" v-for="(item, index) in jdCodeItems" :key="index">
                                <div class="item-title">兑换码</div>
                                <div class="item-content">
                                    <div class="code">{{ item.cardPwd }}</div>
                                    <div class="copy" @click="copy(item)">复制</div>
                                </div>
                            </div>
                        </div>
                        <div class="tip">
                            <div class="tip-title">使用说明：</div>
                            <div class="tip-desc">
                                <div>
                                    登录京东APP，找到我的 -
                                    京东E卡进行绑定。付款时选择京东E卡付款，只限于购买京东自营产品。
                                </div>
                                <div>
                                    请领取成功后，尽快绑定。使用时间以绑定成功后，E卡展示时间为主。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <div class="continue btn" @click="continueBtn">知道了</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'homeDialog',
    props: ['offerNo', 'jdCodeItems'],
    data() {
        return {
            items: []
        };
    },
    created() {
    },
    methods: {
        continueBtn() {
            this.$emit('continueBtn');
        },
        copy(item) {
            this.$copyText(item.cardPwd).then(
                () => {
                    this.$toast({ message: '复制成功', duration: 2000 });
                },
                () => {
                    this.$toast({ message: '复制失败', duration: 2000 });
                }
            );
        }
    }
};
</script>
<style lang="less" scoped>
// @import '../../common/style/common.less';
.container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    z-index: 1111;
    justify-content: center;
    align-items: center;
}
.box-share {
    z-index: 1;
    .box-content {
        z-index: 1;
        width: 303px;
        display: flex;
        border-radius: 8px;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        .box-title {
            margin: 30px 24px 17px;
            font-size: 16px;
            font-weight: 600;
            color: #002a3c;
            line-height: 24px;
            text-align: center;
        }
        .btn-container {
            width: 100%;
            padding: 0 24px;
            &-content {
                .list {
                    background: #f5f8fa;
                    border-radius: 4px;
                    margin-left: auto;
                    margin-right: auto;
                    padding: 0 16px;
                    .item {
                        padding: 17px 0;
                        border-bottom: 1px solid #dce1e6;
                        &:last-child {
                            border-bottom: none;
                        }
                        &-title {
                            font-size: 14px;
                            font-weight: 600;
                            color: #002a3c;
                        }
                        &-content {
                            margin-top: 8px;
                            display: flex;
                            justify-content: space-between;
                            .code {
                                font-size: 13px;
                                font-weight: 400;
                                color: #49596c;
                            }
                            .copy {
                                font-weight: 600;
                                font-size: 13px;
                                color: #3ca5e2;
                            }
                        }
                    }
                }

                .tip {
                    width: 255px;
                    font-size: 13px;
                    font-weight: 400;
                    color: #49596c;
                    line-height: 22px;
                    margin-top: 20px;
                    .top-title {
                        font-weight: 600;
                    }
                }
            }
            .footer {
                display: flex;
                justify-content: space-between;
                margin-top: 30px;
                margin-bottom: 22px;
                .btn {
                    height: 45px;
                    border-radius: 8px;
                    line-height: 45px;
                    text-align: center;
                    font-size: 16px;
                    font-weight: 600;
                }
                .continue {
                    width: 100%;
                    background: linear-gradient(270deg, #3ca5e2 0%, #4dbaf9 100%);
                    color: #ffffff;
                }
            }
        }
    }
}
</style>
